export default "__VITE_ASSET__DMld6vOp__"